import { createSelector } from 'reselect';

const selector = (state, form) => {
  return state.forms[form].asMutable({ deep: true });
}

export default createSelector(
  [selector], form => form
)



// WEBPACK FOOTER //
// ./src/selectors/form-selector.js